import React, { useState, useMemo } from 'react';
import ReinnoireCard from '../Shared/ReinnoireCard';
import DateField from '../Shared/DateField';
import ProceduraFileSection from '../Shared/ProceduraFileSection';
import { FilterPill } from '../Shared/FilterPill';
import './Tracker.css';

/* ── Tarife OSIM brevet national (LEI, Anexa 1 la O.G. 41/1998, valabile 01.01.2026) ── */
const TARIFE_OSIM_DEFAULT = {
  inreg_hartie:             152,
  inreg_electronic:         102,
  publicare_18:             254,
  publicare_anticipata:     508,   // pct. 5a — nereductibil
  raport_national:          508,
  raport_international:     254,
  raport_extins:           1524,   // pct. 6c — nereductibil
  exam_baza:               1524,
  exam_pagina:               25,
  exam_revendicare:          51,
  exam_rapid_baza:         2541,   // pct. 7 — nereductibil
  exam_rapid_pagina:         51,
  exam_rapid_revendicare:    76,
  eliberare:                508,
  eliberare_pagina:          25,
  prioritate:               254,
  faza_nationala:           152,
};

/* pct. 23 — anuitati brevet national (lei, 2026) */
const ANUITATI_OSIM_DEFAULT = {
  1:0, 2:0, 3:762, 4:813, 5:915, 6:1016, 7:1118, 8:1219,
  9:1321, 10:1423, 11:1524, 12:1626, 13:1728, 14:1880,
  15:2032, 16:2541, 17:2541, 18:2541, 19:2541, 20:2541,
};

/* ── Taxe OEB (EUR, valabile 01.04.2026, CA/D 9/25) ── */
const TAXE_OEB_DEFAULT = {
  depunere_online:    135,
  depunere_hartie:    285,
  pagina_peste_35:     18,
  documentare:       1595,
  desemnare:          720,
  examinare_1:       2010,   // EP direct + Euro-PCT daca OEB nu a fost ISA
  examinare_2:       2240,   // Euro-PCT daca OEB a fost ISA
  revendicare_16_50:  290,
  revendicare_51:     720,
  acordare:          1135,
  opozitie:           880,
  continuare_procedura: 315,
  restabilire:        790,
};

/* Anuitati OEB pe durata examinarii (EUR, 01.04.2026) */
const ANUITATI_OEB_DEFAULT = {
  3:725, 4:885, 5:1050, 6:1215, 7:1375, 8:1540, 9:1700,
  10:1865, 11:1865, 12:1865, 13:1865, 14:1865, 15:1865,
  16:1865, 17:1865, 18:1865, 19:1865, 20:1865,
};

/* Taxe OSIM pentru efectele in Romania ale brevetului european (lei, 01.01.2026) */
const TAXE_OSIM_VALID_DEFAULT = {
  revendicari_provizoriu:  305,   // pct. 29
  revendicari_corectate:   152,   // pct. 30
  fascicul_3luni:          508,   // pct. 31a
  fascicul_6luni:         1016,   // pct. 31b
  fascicul_pagina:          25,
  fascicul_opozitie_3luni: 254,
  fascicul_opozitie_6luni: 508,
  traducere_corectata:     102,   // pct. 36
  certificat_recunoastere:  51,   // pct. 37
  transmitere_drepturi:    508,   // pct. 35
};

/* Anuitati OSIM pentru brevetul european validat (lei, 01.01.2026) */
const ANUITATI_OSIM_VALID_DEFAULT = {
  1:0, 2:0, 3:762, 4:813, 5:915, 6:1016, 7:1118, 8:1219,
  9:1321, 10:1423, 11:1524, 12:1626, 13:1728, 14:1880,
  15:2032, 16:2541, 17:2541, 18:2541, 19:2541, 20:2541,
};

/* Anuitati brevet cu efect unitar (EUR, orientativ) */
const ANUITATI_UNITAR_DEFAULT = {
  2:35, 3:105, 4:145, 5:315, 6:475, 7:630, 8:815, 9:990,
  10:1175, 11:1460, 12:1775, 13:2105, 14:2455, 15:2830,
  16:3240, 17:3640, 18:4055, 19:4455, 20:4855,
};

/* Regim lingvistic la validare: 0=fara traducere, 1=doar revendicari, 2=traducere integrala */
const STATE_VALIDARE = [
  ['DE','Germania',0],['FR','Franta',0],['GB','Regatul Unit',0],
  ['BE','Belgia',0],['IE','Irlanda',0],['LU','Luxemburg',0],
  ['MC','Monaco',0],['CH/LI','Elvetia / Liechtenstein',0],
  ['NL','Tarile de Jos',1],['DK','Danemarca',1],['SE','Suedia',1],
  ['FI','Finlanda',1],['NO','Norvegia',1],['IS','Islanda',1],
  ['HU','Ungaria',1],['HR','Croatia',1],['SI','Slovenia',1],
  ['LV','Letonia',1],['LT','Lituania',1],['MK','Macedonia de Nord',1],
  ['AL','Albania',1],['SM','San Marino',1],
  ['RO','Romania',2],['IT','Italia',2],['ES','Spania',2],
  ['PL','Polonia',2],['PT','Portugalia',2],['AT','Austria',2],
  ['GR','Grecia',2],['BG','Bulgaria',2],['CZ','Cehia',2],
  ['SK','Slovacia',2],['TR','Turcia',2],['RS','Serbia',2],
];

const REGIM_LABEL = ['fara traducere','doar revendicarile','traducere integrala'];

const REDUCERI = [
  ['100','Fara reducere (taxa integrala)'],
  ['50','50% — persoana fizica / juridica sub 2 mil. EUR (art. 2 O.G. 41/1998)'],
  ['20','20% — persoana juridica sub 1 mil. EUR / institutie publica (art. 2 O.G. 41/1998)'],
];

const SECTIUNI_IPC = [
  ['A','Necesitati curente ale vietii'],['B','Tehnici industriale diverse; transport'],
  ['C','Chimie; metalurgie'],['D','Textile; hartie'],
  ['E','Constructii fixe'],['F','Mecanica; iluminat; incalzire; armament'],
  ['G','Fizica'],['H','Electricitate'],
];

/* ── Helpers ── */
const todayMid  = () => { const d = new Date(); d.setHours(0,0,0,0); return d; };
const parseISO  = (s) => (s ? new Date(s + 'T00:00:00') : null);
const addMonths = (d, m) => { const x = new Date(d); x.setMonth(x.getMonth() + m); return x; };
const addYears  = (d, y) => { const x = new Date(d); x.setFullYear(x.getFullYear() + y); return x; };
const endOfMonth = (d) => new Date(d.getFullYear(), d.getMonth() + 1, 0);
const maxDate   = (a, b) => (a && b ? (a > b ? a : b) : a || b);
const fmtRO  = (d) => d ? d.toLocaleDateString('ro-RO', { day:'2-digit', month:'2-digit', year:'numeric' }) : '—';
const daysLeft = (d) => d ? Math.ceil((d - todayMid()) / 86400000) : null;
const fmtLei = (n) => Math.round(Number(n)).toLocaleString('ro-RO') + ' lei';
const fmtEur = (n) => Math.round(Number(n)).toLocaleString('ro-RO') + ' €';

/* ── emptyRecord export ── */
export function emptyRecord() {
  return {
    /* comun */
    oficiu: 'osim',             // osim | epo | pct
    denumire: '',               // titlul inventiei
    solicitant: '',
    inventatori: '',
    depusa: false,
    numar: '',                  // nr. cerere (backward compat)
    numarCerere: '',
    numarPublicare: '',
    numarBrevet: '',
    dataInregistrare: '',
    dataExpirare: '',
    dataDepunere: '',           // data depunerii / depozitului
    dataPrioritate: '',
    nrPrioritate: '',
    certificatPrimit: false,
    transmisClient: false,
    observatii: '',

    /* OSIM national */
    tipCerere: 'nationala',     // nationala | pct | divizionara | transformare_ep
    modDepunere: 'electronic',
    ipc: '',
    pagini: 20,
    revendicari: 5,
    reducere: '100',            // 100 | 50 | 20
    prioritate: false,
    publicareAnticipata: false,
    raportTip: 'national',      // fara | national | international | extins
    examinareTip: 'normal',     // normal | rapid
    taxaInregPlatita: false,
    taxaPublicarePlatita: false,
    dataPublicareCerere: '',
    dataPlataExaminare: '',
    dataHotarare: '',
    taxaEliberarePlatita: false,
    dataPublicareMentiune: '',
    brevetPrimit: false,
    anuitati: {},               // { "3": true, "4": true, ... }

    /* EPO */
    tip: 'direct',              // direct | europct
    oebEsteIsa: false,
    limba: 'en',
    modDepunereEpo: 'online',   // online | hartie
    paginiBrevet: 35,
    revendicariBrevet: 15,
    taxeInitialePlatite: false,
    dataRaport: '',
    examinareCeruta: false,
    data71_3: '',
    taxaAcordarePlatita: false,
    dataMentiuneEliberare: '',
    unitar: false,
    cerereUnitaraDepusa: false,
    protectieProvizorie: false,
    validareRO: false,
    validareROTermen: '3luni',
    validareROPagini: 20,
    validareRODepusa: false,
    certificatRecunoastere: false,
    validari: {},               // { "DE": { cost: 0 } }
    anuitatiOEB: {},
    anuitatiRO: {},
    anuitatiUnitar: {},

    /* backward compat fields */
    dataRaportCautare: '',
    dataPublicare: '',
    dataExaminare: '',
    dataAcordare: '',
    tariValidare: '',
  };
}

/* ═══════════════════ OSIM — Fee calc & timeline ═══════════════════ */

function calcTaxeOsim(r, T) {
  const pct  = Number(r.reducere) / 100;
  const red  = (v) => v * pct;
  const pagSupl = Math.max(0, Number(r.pagini || 0) - 20);
  const revSupl = Math.max(0, Number(r.revendicari || 0) - 5);

  const inreg = red(r.modDepunere === 'hartie' ? T.inreg_hartie : T.inreg_electronic);
  const fazaNat = r.tipCerere === 'pct' ? red(T.faza_nationala) : 0;
  const publicare = r.publicareAnticipata ? T.publicare_anticipata : red(T.publicare_18);

  let raport = 0;
  if (r.raportTip === 'national')      raport = red(T.raport_national);
  else if (r.raportTip === 'international') raport = red(T.raport_international);
  else if (r.raportTip === 'extins')   raport = T.raport_extins;

  const rapid = r.examinareTip === 'rapid';
  const examBaza = rapid ? T.exam_rapid_baza : T.exam_baza;
  const examPag  = pagSupl * (rapid ? T.exam_rapid_pagina : T.exam_pagina);
  const examRev  = revSupl * (rapid ? T.exam_rapid_revendicare : T.exam_revendicare);
  const examinare = rapid ? (examBaza + examPag + examRev) : red(examBaza + examPag + examRev);

  const eliberare = red(T.eliberare + pagSupl * T.eliberare_pagina);
  const prior = r.prioritate ? red(T.prioritate) : 0;
  const total = inreg + fazaNat + publicare + raport + examinare + eliberare + prior;

  return { pct, pagSupl, revSupl, rapid, inreg, fazaNat, publicare, raport,
    examinare, examBaza, examPag, examRev, eliberare, prior, total };
}

function calcAnuitatiOsim(r, ANU) {
  const dep  = parseISO(r.dataDepunere);
  const ment = parseISO(r.dataPublicareMentiune);
  if (!dep) return { rows:[], totalRamas:0, totalIntegral:0, urmatoarea:null, expirare:null };
  const primaScadenta = ment ? addMonths(ment, 12) : null;
  const pct = Number(r.reducere) / 100;
  const rows = [];
  let totalRamas = 0, totalIntegral = 0, urmatoarea = null;
  for (let an = 1; an <= 20; an++) {
    const brut = ANU[an] ?? 0;
    if (brut === 0) continue;
    const suma = an <= 5 ? brut * pct : brut;
    const start = addYears(dep, an - 1);
    const scadenta = primaScadenta ? maxDate(start, primaScadenta) : start;
    const gratie = addMonths(scadenta, 6);
    const platit = !!r.anuitati[an];
    totalIntegral += suma;
    if (!platit) totalRamas += suma;
    if (!platit && !urmatoarea) urmatoarea = { an, scadenta, suma, gratie };
    rows.push({ an, brut, suma, start, scadenta, gratie, platit, redus: an <= 5 && pct < 1 });
  }
  return { rows, totalRamas, totalIntegral, urmatoarea, expirare: addYears(dep, 20) };
}

function deriveStatusOsim(r) {
  const dep  = parseISO(r.dataDepunere);
  const prio = parseISO(r.dataPrioritate);
  const hot  = parseISO(r.dataHotarare);
  const ment = parseISO(r.dataPublicareMentiune);
  const plataExam = parseISO(r.dataPlataExaminare);

  const termenInreg    = dep  ? addMonths(dep, 3)  : null;
  const termenPublicare= prio ? addMonths(prio, 16) : dep ? addMonths(dep, 6) : null;
  const publicareEstimata = dep ? addMonths(prio || dep, 18) : null;
  const termenExaminare= dep  ? addMonths(dep, 30) : null;
  const termenExamRapid= dep  ? addMonths(dep, 3)  : null;
  const examEstimata   = plataExam ? addMonths(plataExam, 18)
    : r.examinareTip === 'rapid' && dep ? addMonths(dep, 18) : null;
  const termenEliberare= hot  ? addMonths(hot, 4)  : null;
  const termenContestatie = hot ? addMonths(hot, 3) : null;
  const opozitieEnd    = ment ? addMonths(ment, 6) : null;
  const opozitieEnded  = opozitieEnd ? todayMid() >= opozitieEnd : false;
  const expirare       = dep  ? addYears(dep, 20)  : null;
  const termenPCT      = (prio || dep) ? addMonths(prio || dep, 12) : null;

  const registered = !!(r.dataInregistrare || r.brevetPrimit);

  const steps = [
    { key:'depunere',  label:'Depunere',          done: registered || !!r.depusa,                date: dep },
    { key:'taxa1',     label:'Taxa inregistrare', done: registered || r.taxaInregPlatita,        date: termenInreg },
    { key:'publicare', label:'Publicare cerere',  done: registered || !!r.dataPublicareCerere,   date: parseISO(r.dataPublicareCerere) || publicareEstimata },
    { key:'examinare', label:'Taxa examinare',    done: registered || !!r.dataPlataExaminare,    date: plataExam || termenExaminare },
    { key:'hotarare',  label:'Hotarare acordare', done: registered || !!hot,                     date: hot || examEstimata },
    { key:'eliberare', label:'Taxa eliberare',    done: registered || r.taxaEliberarePlatita,    date: termenEliberare },
    { key:'mentiune',  label:'Mentiune BOPI',     done: registered || !!ment,                    date: ment },
    { key:'opozitie',  label:'Opozitie (6 luni)', done: registered || opozitieEnded,             date: opozitieEnd },
    { key:'brevet',    label:'Brevet eliberat',   done: r.brevetPrimit,          date: null },
    { key:'client',    label:'Transmis client',   done: r.transmisClient,        date: null },
  ];

  let alert;
  if (registered)              alert = (r.brevetPrimit && !r.transmisClient)
    ? { label:'De transmis brevetul catre client', sev:'act' }
    : { label:'Brevet in vigoare — se urmaresc anuitatile', sev:'done' };
  else if (!r.depusa)          alert = { label:'In pregatire — de depus la OSIM', sev:'neutral' };
  else if (!r.taxaInregPlatita) alert = { label:'Taxa de inregistrare (3 luni de la depunere)', date:termenInreg, sev:'act' };
  else if (!r.taxaPublicarePlatita) alert = { label:'Taxa de publicare a cererii', date:termenPublicare, sev:'act' };
  else if (!r.dataPlataExaminare) alert = {
    label: r.examinareTip === 'rapid'
      ? 'Taxa de examinare rapida (3 luni de la depozit)'
      : 'De solicitat examinarea de fond — decade in luna a 30-a',
    date: r.examinareTip === 'rapid' ? termenExamRapid : termenExaminare, sev:'act',
  };
  else if (!hot) alert = { label:'In examinare de fond (18 luni de la plata)', date:examEstimata, sev:'info' };
  else if (!r.taxaEliberarePlatita) alert = { label:'Taxa de publicare, tiparire si eliberare (4 luni de la comunicare)', date:termenEliberare, sev:'act' };
  else if (!ment) alert = { label:'Asteptare publicare mentiune hotarare in BOPI', sev:'info' };
  else if (!opozitieEnded) alert = { label:'Perioada de opozitie (6 luni de la mentiune)', date:opozitieEnd, sev:'watch' };
  else if (!r.brevetPrimit) alert = { label:'De ridicat / primit brevetul', sev:'act' };
  else if (!r.transmisClient) alert = { label:'De transmis brevetul catre client', sev:'act' };
  else alert = { label:'Brevet in vigoare — se urmaresc anuitatile', sev:'done' };

  if (alert.date) { const dl = daysLeft(alert.date); alert.daysLeft = dl; if (dl < 0) alert.sev = 'overdue'; }
  return { steps, alert, dep, prio, hot, ment,
    termenInreg, termenPublicare, publicareEstimata, termenExaminare, termenExamRapid,
    examEstimata, termenEliberare, termenContestatie, opozitieEnd, opozitieEnded,
    expirare, termenPCT };
}

/* ═══════════════════ EPO — Fee calc & timeline ═══════════════════ */

function calcTaxeOeb(r, T) {
  const pagSupl = Math.max(0, Number(r.paginiBrevet || 0) - 35);
  const rev  = Number(r.revendicariBrevet || 0);
  const rev16 = Math.max(0, Math.min(rev, 50) - 15);
  const rev51 = Math.max(0, rev - 50);
  const depunere = r.modDepunereEpo === 'hartie' ? T.depunere_hartie : T.depunere_online;
  const pagini   = pagSupl * T.pagina_peste_35;
  const documentare = r.tip === 'europct' && r.oebEsteIsa ? 0 : T.documentare;
  const examinare   = r.tip === 'europct' && r.oebEsteIsa ? T.examinare_2 : T.examinare_1;
  const revendicari = rev16 * T.revendicare_16_50 + rev51 * T.revendicare_51;
  const desemnare   = T.desemnare;
  const acordare    = T.acordare;
  const total = depunere + pagini + documentare + revendicari + desemnare + examinare + acordare;
  return { pagSupl, rev16, rev51, depunere, pagini, documentare, examinare, revendicari, desemnare, acordare, total };
}

function calcTaxeOsimValidare(r, T) {
  if (!r.validareRO) return { total:0, fascicul:0, pagSupl:0, provizoriu:0, certificat:0, baza:0, paginiSupl:0 };
  const pagSupl = Math.max(0, Number(r.validareROPagini || 0) - 20);
  const baza = r.validareROTermen === '6luni' ? T.fascicul_6luni : T.fascicul_3luni;
  const paginiSupl = pagSupl * T.fascicul_pagina;
  const fascicul = baza + paginiSupl;
  const provizoriu = r.protectieProvizorie ? T.revendicari_provizoriu : 0;
  const certificat = r.certificatRecunoastere ? T.certificat_recunoastere : 0;
  return { total: fascicul + provizoriu + certificat, fascicul, baza, pagSupl, paginiSupl, provizoriu, certificat };
}

function calcAnuitatiOEB(r, tabel) {
  const dep  = parseISO(r.dataDepunere);
  const ment = parseISO(r.dataMentiuneEliberare);
  if (!dep) return { rows:[], urmatoarea:null, total:0 };
  const rows = []; let total = 0, urmatoarea = null;
  for (let an = 3; an <= 20; an++) {
    const suma = tabel[an] ?? 0;
    const aniv = addYears(dep, an - 1);
    const scadenta = endOfMonth(aniv);
    if (ment && scadenta > ment) break;
    const platit = !!r.anuitatiOEB[an];
    if (!platit && !urmatoarea) urmatoarea = { an, scadenta, suma };
    total += suma;
    rows.push({ an, suma, scadenta, gratie: addMonths(scadenta, 6), platit });
  }
  return { rows, urmatoarea, total };
}

function calcAnuitatiRO(r, tabel) {
  const dep  = parseISO(r.dataDepunere);
  const ment = parseISO(r.dataMentiuneEliberare);
  if (!dep || !r.validareRO) return { rows:[], urmatoarea:null, total:0, expirare:null };
  const rows = []; let total = 0, urmatoarea = null;
  for (let an = 1; an <= 20; an++) {
    const brut = tabel[an] ?? 0;
    if (brut === 0) continue;
    const start = addYears(dep, an - 1);
    if (ment && start < ment) continue;
    const scadenta = ment ? maxDate(start, addMonths(ment, 3)) : start;
    const platit = !!r.anuitatiRO[an];
    if (!platit && !urmatoarea) urmatoarea = { an, scadenta, suma: brut };
    total += brut;
    rows.push({ an, suma: brut, start, scadenta, gratie: addMonths(scadenta, 6), platit });
  }
  return { rows, urmatoarea, total, expirare: addYears(dep, 20) };
}

function calcAnuitatiUnitar(r, tabel) {
  const dep  = parseISO(r.dataDepunere);
  if (!dep || !r.unitar) return { rows:[], urmatoarea:null, total:0 };
  const ment = parseISO(r.dataMentiuneEliberare);
  const rows = []; let total = 0, urmatoarea = null;
  for (let an = 2; an <= 20; an++) {
    const suma = tabel[an] ?? 0;
    const scadenta = endOfMonth(addYears(dep, an - 1));
    if (ment && scadenta < ment) continue;
    const platit = !!r.anuitatiUnitar[an];
    if (!platit && !urmatoarea) urmatoarea = { an, scadenta, suma };
    total += suma;
    rows.push({ an, suma, scadenta, platit });
  }
  return { rows, urmatoarea, total };
}

function deriveStatusEpo(r) {
  const dep  = parseISO(r.dataDepunere);
  const prio = parseISO(r.dataPrioritate);
  const raport = parseISO(r.dataRaport);
  const com71  = parseISO(r.data71_3);
  const ment   = parseISO(r.dataMentiuneEliberare);

  const termenTaxeInitiale = dep ? addMonths(dep, 1) : null;
  const publicare = (prio || dep) ? addMonths(prio || dep, 18) : null;
  const termenExaminare = raport ? addMonths(raport, 6) : null;
  const termen71_3 = com71 ? addMonths(com71, 4) : null;
  const termenUnitar = ment ? addMonths(ment, 1) : null;
  const termenValidare = ment ? addMonths(ment, r.validareROTermen === '6luni' ? 6 : 3) : null;
  const opozitieEnd  = ment ? addMonths(ment, 9) : null;
  const opozitieEnded = opozitieEnd ? todayMid() >= opozitieEnd : false;
  const termenPrioritate = (prio || dep) ? addMonths(prio || dep, 12) : null;
  const expirare = dep ? addYears(dep, 20) : null;

  const steps = [
    { key:'depunere',  label:'Depunere',               done: r.depusa,                  date: dep },
    { key:'taxe',      label:'Taxe initiale (1 luna)', done: r.taxeInitialePlatite,     date: termenTaxeInitiale },
    { key:'publicare', label:'Publicare A1 (18 luni)', done: !!raport || (publicare ? todayMid() >= publicare : false), date: publicare },
    { key:'examinare', label:'Cerere examinare',       done: r.examinareCeruta,         date: termenExaminare },
    { key:'r713',      label:'Comunicare R. 71(3)',    done: !!com71,                   date: com71 },
    { key:'acordare',  label:'Taxa acordare (4 luni)', done: r.taxaAcordarePlatita,     date: termen71_3 },
    { key:'mentiune',  label:'Mentiune eliberare',     done: !!ment,                    date: ment },
    { key:'validare',  label: r.unitar ? 'Efect unitar' : 'Validare RO',
      done: r.unitar ? r.cerereUnitaraDepusa : r.validareRODepusa,
      date: r.unitar ? termenUnitar : termenValidare },
    { key:'opozitie',  label:'Opozitie (9 luni)',      done: opozitieEnded,             date: opozitieEnd },
  ];

  let alert;
  if (!r.depusa)               alert = { label:'In pregatire — de depus la OEB', sev:'neutral' };
  else if (!r.taxeInitialePlatite) alert = { label:'Taxa de depunere si de documentare (1 luna de la depozit)', date:termenTaxeInitiale, sev:'act' };
  else if (!raport)            alert = { label:'Asteptare raport european de documentare', sev:'info' };
  else if (!r.examinareCeruta) alert = { label:'Cerere de examinare, taxa de desemnare si revendicari — 6 luni de la mentiunea raportului', date:termenExaminare, sev:'act' };
  else if (!com71)             alert = { label:'In examinare de fond la OEB', sev:'info' };
  else if (!r.taxaAcordarePlatita) alert = { label:'Taxa de acordare si traducerea revendicarilor — 4 luni de la R. 71(3)', date:termen71_3, sev:'act' };
  else if (!ment)              alert = { label:'Asteptare publicare mentiune eliberare in Buletinul European', sev:'info' };
  else if (r.unitar && !r.cerereUnitaraDepusa) alert = { label:'Cerere de efect unitar — 1 luna de la mentiunea eliberarii', date:termenUnitar, sev:'act' };
  else if (r.validareRO && !r.validareRODepusa) alert = { label:'Validare in Romania — depunerea traducerii fasciculei', date:termenValidare, sev:'act' };
  else if (!opozitieEnded)     alert = { label:'Perioada de opozitie la OEB (9 luni)', date:opozitieEnd, sev:'watch' };
  else                         alert = { label:'Brevet in vigoare — se urmaresc anuitatile', sev:'done' };

  if (alert.date) { const dl = daysLeft(alert.date); alert.daysLeft = dl; if (dl < 0) alert.sev = 'overdue'; }
  return { steps, alert, dep, prio, raport, com71, ment,
    termenTaxeInitiale, publicare, termenExaminare, termen71_3, termenUnitar,
    termenValidare, opozitieEnd, opozitieEnded, termenPrioritate, expirare };
}

/* ════════════════════════ Component ════════════════════════ */
export default function BrevetTracker({ data, onChange, procId, showToast, pendingFiles, onPendingFilesChange }) {
  const [r, setR] = useState(data);

  const [tarifeOsim, setTarifeOsim] = useState(TARIFE_OSIM_DEFAULT);
  const [anuitatiOsim, setAnuitatiOsim] = useState(ANUITATI_OSIM_DEFAULT);
  const [taxeOeb, setTaxeOeb] = useState(TAXE_OEB_DEFAULT);
  const [anuitatiOEB, setAnuitatiOEB] = useState(ANUITATI_OEB_DEFAULT);
  const [taxeOsimVal, setTaxeOsimVal] = useState(TAXE_OSIM_VALID_DEFAULT);
  const [anuitatiOsimVal, setAnuitatiOsimVal] = useState(ANUITATI_OSIM_VALID_DEFAULT);
  const [anuitatiUnitar, setAnuitatiUnitar] = useState(ANUITATI_UNITAR_DEFAULT);
  const [showTarife, setShowTarife] = useState(false);

  const set = (patch) => { const next = { ...r, ...patch }; setR(next); onChange(next); };

  const isOsim = r.oficiu === 'osim';
  const isEpo  = r.oficiu === 'epo';
  const isPct  = r.oficiu === 'pct';

  const taxeCalcOsim = useMemo(() => calcTaxeOsim(r, tarifeOsim), [r, tarifeOsim]);
  const anuOsim = useMemo(() => calcAnuitatiOsim(r, anuitatiOsim), [r, anuitatiOsim]);
  const taxeCalcOeb = useMemo(() => calcTaxeOeb(r, taxeOeb), [r, taxeOeb]);
  const taxeCalcOsimVal = useMemo(() => calcTaxeOsimValidare(r, taxeOsimVal), [r, taxeOsimVal]);
  const anuOEB = useMemo(() => calcAnuitatiOEB(r, anuitatiOEB), [r, anuitatiOEB]);
  const anuRO  = useMemo(() => calcAnuitatiRO(r, anuitatiOsimVal), [r, anuitatiOsimVal]);
  const anuUnitar = useMemo(() => calcAnuitatiUnitar(r, anuitatiUnitar), [r, anuitatiUnitar]);
  const status = useMemo(() => isEpo ? deriveStatusEpo(r) : deriveStatusOsim(r), [r, isEpo]);

  const costValidari = Object.values(r.validari || {}).reduce((s, v) => s + (Number(v.cost) || 0), 0);

  const toggleAn = (camp, an) => {
    const a = { ...r[camp] };
    if (a[an]) delete a[an]; else a[an] = true;
    set({ [camp]: a });
  };
  const toggleStat = (cod) => {
    const v = { ...r.validari };
    if (v[cod]) delete v[cod]; else v[cod] = { cost: 0 };
    set({ validari: v });
  };

  return (
    <div className="tracker">
      {!isPct && <AlertBanner status={status} />}
      {!isPct && <Timeline steps={status.steps} />}

      {/* Identificare */}
      <TrackerCard title="Identificarea inventiei">
        <div className="f-row">
          <div className="field">
            <label>Titlul inventiei</label>
            <input type="text" value={r.denumire} onChange={e => set({ denumire: e.target.value })} placeholder="ex: Procedeu de obtinere a..." />
          </div>
          <div className="field">
            <label>Oficiu</label>
            <SegControl value={r.oficiu} onChange={v => set({ oficiu: v })}
              options={[['osim','OSIM (national)'],['epo','OEB / EPO'],['pct','WIPO – PCT']]} />
          </div>
        </div>
        <div className="f-row">
          <div className="field">
            <label>Solicitant / Titular</label>
            <input type="text" value={r.solicitant} onChange={e => set({ solicitant: e.target.value })} />
          </div>
          <div className="field">
            <label>Inventatori <span className="f-hint">— separati prin virgula</span></label>
            <input type="text" value={r.inventatori} onChange={e => set({ inventatori: e.target.value })} />
          </div>
        </div>
        {!isPct && (
          <div className="field">
            <label>Documente tehnice <span className="f-hint">— descriere, revendicari, desene</span></label>
            <ProceduraFileSection procId={procId} showToast={showToast} pendingFiles={pendingFiles} onPendingFilesChange={onPendingFilesChange} />
          </div>
        )}
        <div className="f-row">
          <div className="field">
            <label>Prioritate revendicata (data)</label>
            <DateField value={r.dataPrioritate} onChange={v => set({ dataPrioritate: v })} />
          </div>
          <div className="field">
            <label>Nr. cerere prioritate</label>
            <input type="text" value={r.nrPrioritate} onChange={e => set({ nrPrioritate: e.target.value })} className="mono" />
          </div>
        </div>
      </TrackerCard>

      {/* ══ PCT placeholder ══ */}
      {isPct && (
        <TrackerCard title="WIPO — PCT (Patent Cooperation Treaty)">
          <p className="f-hint">Urmarirea fazei internationale si a intrarilor in faza nationala PCT va fi disponibila in curand. Foloseste sectiunea de observatii pentru note de dosar.</p>
        </TrackerCard>
      )}

      {/* ══ OSIM — Optiuni procedura ══ */}
      {isOsim && (
        <TrackerCard title="Optiuni procedura OSIM">
          <div className="f-row">
            <div className="field">
              <label>Tipul cererii</label>
              <FilterPill value={r.tipCerere} onChange={e => set({ tipCerere: e.target.value })}>
                <option value="nationala">Nationala (direct la OSIM)</option>
                <option value="pct">Faza nationala PCT</option>
                <option value="divizionara">Divizionara</option>
                <option value="transformare_ep">Din transformarea unei cereri EP</option>
              </FilterPill>
            </div>
            <div className="field">
              <label>Mod depunere</label>
              <SegControl value={r.modDepunere} onChange={v => set({ modDepunere: v })}
                options={[['electronic',`Electronic (${tarifeOsim.inreg_electronic} lei)`],['hartie',`Pe hartie (${tarifeOsim.inreg_hartie} lei)`]]} />
            </div>
          </div>
          <div className="f-row">
            <div className="field">
              <label>Nr. total pagini <span className="f-hint">— desc. + revendicari + desene</span></label>
              <input type="number" min="1" value={r.pagini} onChange={e => set({ pagini: Number(e.target.value) || 0 })} />
            </div>
            <div className="field">
              <label>Nr. revendicari <span className="f-hint">— peste 5 se taxeaza separat</span></label>
              <input type="number" min="1" value={r.revendicari} onChange={e => set({ revendicari: Number(e.target.value) || 0 })} />
            </div>
            <div className="field">
              <label>Clasa IPC</label>
              <FilterPill value={r.ipc} onChange={e => set({ ipc: e.target.value })}>
                <option value="">— neatribuita —</option>
                {SECTIUNI_IPC.map(([k, v]) => <option key={k} value={k}>{k} · {v}</option>)}
              </FilterPill>
            </div>
          </div>
          <div className="f-row">
            <div className="field">
              <label>Publicarea cererii</label>
              <SegControl value={r.publicareAnticipata ? 'anticipata' : 'standard'}
                onChange={v => set({ publicareAnticipata: v === 'anticipata' })}
                options={[['standard',`La 18 luni (${tarifeOsim.publicare_18} lei)`],['anticipata',`Anticipata (${tarifeOsim.publicare_anticipata} lei) — fara reducere`]]} />
            </div>
          </div>
          <div className="field">
            <label>Raport de documentare</label>
            <FilterPill value={r.raportTip} onChange={e => set({ raportTip: e.target.value })}>
              <option value="fara">Fara raport separat</option>
              <option value="national">Cerere nationala ({tarifeOsim.raport_national} lei)</option>
              <option value="international">Cerere internationala — faza nationala ({tarifeOsim.raport_international} lei)</option>
              <option value="extins">Extins cu opinie scrisa ({tarifeOsim.raport_extins} lei — fara reducere)</option>
            </FilterPill>
          </div>
          <div className="field">
            <label>Examinarea de fond</label>
            <SegControl value={r.examinareTip} onChange={v => set({ examinareTip: v })}
              options={[['normal','Standard (pct. 3)'],['rapid','In 18 luni de la depozit, pct. 7 — fara reducere']]} />
          </div>
          <div className="field">
            <label>Reducere de taxe (art. 2 O.G. 41/1998)</label>
            <FilterPill value={r.reducere} onChange={e => set({ reducere: e.target.value })}>
              {REDUCERI.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </FilterPill>
          </div>
        </TrackerCard>
      )}

      {/* ══ EPO — Optiuni procedura ══ */}
      {isEpo && (
        <TrackerCard title="Optiuni procedura OEB">
          <div className="f-row">
            <div className="field">
              <label>Calea de intrare</label>
              <SegControl value={r.tip} onChange={v => set({ tip: v })}
                options={[['direct','EP direct'],['europct','Euro-PCT']]} />
            </div>
            {r.tip === 'europct' && (
              <div className="field">
                <label className="check-label">
                  <input type="checkbox" checked={r.oebEsteIsa} onChange={e => set({ oebEsteIsa: e.target.checked })} />
                  OEB a fost autoritate de documentare internationala (ISA)
                </label>
                <span className="f-hint">Fara taxa documentare suplimentara; taxa examinare majora.</span>
              </div>
            )}
          </div>
          <div className="f-row">
            <div className="field">
              <label>Mod depunere</label>
              <SegControl value={r.modDepunereEpo} onChange={v => set({ modDepunereEpo: v })}
                options={[['online',`Online (${taxeOeb.depunere_online} €)`],['hartie',`Pe hartie (${taxeOeb.depunere_hartie} €)`]]} />
            </div>
            <div className="field">
              <label>Limba procedurii</label>
              <FilterPill value={r.limba} onChange={e => set({ limba: e.target.value })}>
                <option value="en">Engleza</option>
                <option value="fr">Franceza</option>
                <option value="de">Germana</option>
                <option value="alta">Alta limba (cu traducere)</option>
              </FilterPill>
            </div>
          </div>
          <div className="f-row">
            <div className="field">
              <label>Nr. pagini <span className="f-hint">— peste 35 se taxeaza suplimentar</span></label>
              <input type="number" min="1" value={r.paginiBrevet || 35} onChange={e => set({ paginiBrevet: Number(e.target.value) || 0 })} />
            </div>
            <div className="field">
              <label>Nr. revendicari <span className="f-hint">— 16–50 si 51+ se taxeaza separat</span></label>
              <input type="number" min="1" value={r.revendicariBrevet || 15} onChange={e => set({ revendicariBrevet: Number(e.target.value) || 0 })} />
            </div>
          </div>
        </TrackerCard>
      )}

      {/* ══ OSIM — Calcul taxe ══ */}
      {isOsim && (
        <TrackerCard title="Calcul taxe OSIM" badge="Anexa 1 · tarife 01.01.2026, LEI">
          {r.reducere !== '100' && (
            <p className="tr-note">Se plateste {r.reducere}% din fiecare taxa reductibila. Dovada conditiilor se prezinta la data platii (art. 3 alin. 1 O.G. 41/1998).</p>
          )}
          <table className="fee-table">
            <tbody>
              <FeeRow lei label={`Inregistrarea cererii — ${r.modDepunere === 'hartie' ? 'pe hartie' : 'electronic'} (pct. 1)`} value={taxeCalcOsim.inreg} />
              {r.tipCerere === 'pct' && <FeeRow lei label="Deschiderea fazei nationale (pct. 26)" value={taxeCalcOsim.fazaNat} />}
              {r.prioritate && <FeeRow lei label="Revendicarea prioritatii (pct. 8a)" value={taxeCalcOsim.prior} />}
              <FeeRow lei label={r.publicareAnticipata ? 'Publicare anticipata (pct. 5a — nereductibila)' : 'Publicarea cererii la 18 luni (pct. 2)'} value={taxeCalcOsim.publicare} />
              {r.raportTip !== 'fara' && (
                <FeeRow lei label={`Raport de documentare (pct. 6${r.raportTip === 'extins' ? 'c — nereductibil' : r.raportTip === 'national' ? 'a' : 'b'})`} value={taxeCalcOsim.raport} />
              )}
              <FeeRow lei label={`Examinare de fond — baza (pct. ${taxeCalcOsim.rapid ? '7a — nereductibila' : '3a'})`}
                value={taxeCalcOsim.rapid ? taxeCalcOsim.examBaza : taxeCalcOsim.examBaza * taxeCalcOsim.pct} />
              {taxeCalcOsim.pagSupl > 0 && (
                <FeeRow lei label={`Pagini peste 20 (${taxeCalcOsim.pagSupl} × ${taxeCalcOsim.rapid ? tarifeOsim.exam_rapid_pagina : tarifeOsim.exam_pagina} lei)`}
                  value={taxeCalcOsim.rapid ? taxeCalcOsim.examPag : taxeCalcOsim.examPag * taxeCalcOsim.pct} />
              )}
              {taxeCalcOsim.revSupl > 0 && (
                <FeeRow lei label={`Revendicari peste 5 (${taxeCalcOsim.revSupl} × ${taxeCalcOsim.rapid ? tarifeOsim.exam_rapid_revendicare : tarifeOsim.exam_revendicare} lei)`}
                  value={taxeCalcOsim.rapid ? taxeCalcOsim.examRev : taxeCalcOsim.examRev * taxeCalcOsim.pct} />
              )}
              <FeeRow lei label={`Publicare, tiparire si eliberare brevet (pct. 4)${taxeCalcOsim.pagSupl > 0 ? ` — incl. ${taxeCalcOsim.pagSupl} pag. supl.` : ''}`}
                value={taxeCalcOsim.eliberare} muted />
            </tbody>
            <tfoot>
              <tr className="fee-total">
                <td>Total taxe pana la eliberare{r.reducere !== '100' ? ` (red. ${r.reducere}%)` : ''}</td>
                <td>{fmtLei(taxeCalcOsim.total)}</td>
              </tr>
            </tfoot>
          </table>
          <p className="f-hint mt4">Nu include anuitatile de mentinere in vigoare — vezi scadentarul de mai jos.</p>
          <button type="button" className="btn-link mt8" onClick={() => setShowTarife(s => !s)}>
            {showTarife ? '▾' : '▸'} Tarife oficiale (editabile)
          </button>
          {showTarife && <TarifeEditorOsim tarife={tarifeOsim} anuitati={anuitatiOsim}
            setTarife={setTarifeOsim} setAnuitati={setAnuitatiOsim} />}
        </TrackerCard>
      )}

      {/* ══ EPO — Calcul taxe OEB ══ */}
      {isEpo && (
        <TrackerCard title="Calcul taxe OEB" badge="tarife 01.04.2026, EUR">
          <table className="fee-table">
            <tbody>
              <FeeRow label={`Taxa de depunere (${r.modDepunereEpo === 'hartie' ? 'pe hartie' : 'online'})`} value={taxeCalcOeb.depunere} />
              {taxeCalcOeb.pagSupl > 0 && <FeeRow label={`Pagini peste 35 (${taxeCalcOeb.pagSupl} × ${taxeOeb.pagina_peste_35} €)`} value={taxeCalcOeb.pagini} />}
              {taxeCalcOeb.documentare > 0 && <FeeRow label="Taxa de documentare europeana" value={taxeCalcOeb.documentare} />}
              {taxeCalcOeb.rev16 > 0 && <FeeRow label={`Revendicarile 16–50 (${taxeCalcOeb.rev16} × ${taxeOeb.revendicare_16_50} €)`} value={taxeCalcOeb.rev16 * taxeOeb.revendicare_16_50} />}
              {taxeCalcOeb.rev51 > 0 && <FeeRow label={`Revendicarile de la 51 (${taxeCalcOeb.rev51} × ${taxeOeb.revendicare_51} €)`} value={taxeCalcOeb.rev51 * taxeOeb.revendicare_51} />}
              <FeeRow label="Taxa de desemnare (toate statele)" value={taxeCalcOeb.desemnare} />
              <FeeRow label={`Taxa de examinare${r.tip === 'europct' && r.oebEsteIsa ? ' (Euro-PCT, OEB = ISA)' : ''}`} value={taxeCalcOeb.examinare} />
              <FeeRow label="Taxa de acordare si publicare" value={taxeCalcOeb.acordare} muted />
            </tbody>
            <tfoot>
              <tr className="fee-total">
                <td>Total taxe OEB pana la eliberare</td>
                <td>{fmtEur(taxeCalcOeb.total)}</td>
              </tr>
            </tfoot>
          </table>
          <p className="f-hint mt4">Fara anuitatile pe durata examinarii, fara onorariile mandatarului si fara costurile de traducere.</p>
          <button type="button" className="btn-link mt8" onClick={() => setShowTarife(s => !s)}>
            {showTarife ? '▾' : '▸'} Tarife oficiale (editabile)
          </button>
          {showTarife && <TarifeEditorOeb
            taxe={taxeOeb} setTaxe={setTaxeOeb}
            anuOEB={anuitatiOEB} setAnuOEB={setAnuitatiOEB}
            anuOsimVal={anuitatiOsimVal} setAnuOsimVal={setAnuitatiOsimVal}
            anuUnitar={anuitatiUnitar} setAnuUnitar={setAnuitatiUnitar} />}
        </TrackerCard>
      )}

      {/* ══ OSIM — Depunere + monitorizare ══ */}
      {isOsim && (
        <TrackerCard title="Depunere si monitorizare OSIM">
          <label className="check-label">
            <input type="checkbox" checked={r.depusa} onChange={e => set({ depusa: e.target.checked })} />
            <strong>Cererea a fost depusa la OSIM</strong>
          </label>
          {r.depusa && (
            <div className="dep-section">
              <div className="f-row">
                <div className="field">
                  <label>Nr. cerere (depozit national)</label>
                  <input type="text" value={r.numarCerere || r.numar} onChange={e => set({ numarCerere: e.target.value })} placeholder="ex. a 2026 00123" className="mono" />
                </div>
                <div className="field">
                  <label>Data de depozit</label>
                  <DateField value={r.dataDepunere} onChange={v => set({ dataDepunere: v })} />
                </div>
              </div>
              <div className="f-row">
                {status.termenInreg && <DeadlineChip label="Taxa inregistrare (3 luni)" date={status.termenInreg} act />}
                {status.termenPublicare && <DeadlineChip label="Taxa publicare cerere" date={status.termenPublicare} act />}
              </div>
              <div className="f-row">
                {status.publicareEstimata && <DeadlineChip label="Publicare estimata (18 luni)" date={status.publicareEstimata} />}
                {status.termenExaminare && <DeadlineChip label={`Limita examinare ${r.examinareTip === 'rapid' ? '(3 luni)' : '(luna 30)'}`} date={r.examinareTip === 'rapid' ? status.termenExamRapid : status.termenExaminare} act />}
              </div>
              <label className="check-label mt4">
                <input type="checkbox" checked={r.taxaInregPlatita} onChange={e => set({ taxaInregPlatita: e.target.checked })} />
                Taxa de inregistrare achitata
              </label>
              <label className="check-label">
                <input type="checkbox" checked={r.taxaPublicarePlatita} onChange={e => set({ taxaPublicarePlatita: e.target.checked })} />
                Taxa de publicare achitata
              </label>

              <div className="tr-divider">Publicare si examinare</div>

              <div className="f-row">
                <div className="field">
                  <label>Data publicarii cererii in BOPI</label>
                  <DateField value={r.dataPublicareCerere} onChange={v => set({ dataPublicareCerere: v })} />
                </div>
                <div className="field">
                  <label>Data platii taxei de examinare <span className="f-hint">— examinarea se face in 18 luni</span></label>
                  <DateField value={r.dataPlataExaminare} onChange={v => set({ dataPlataExaminare: v })} />
                </div>
              </div>

              <div className="tr-divider">Hotararea de acordare</div>

              <div className="f-row">
                <div className="field">
                  <label>Data comunicarii hotararii <span className="f-hint">— 4 luni pentru taxa eliberare</span></label>
                  <DateField value={r.dataHotarare} onChange={v => set({ dataHotarare: v })} />
                </div>
                <div className="field">
                  <label>Data publicarii mentiunii in BOPI <span className="f-hint">— porneste opozitia (6 luni)</span></label>
                  <DateField value={r.dataPublicareMentiune} onChange={v => set({ dataPublicareMentiune: v })} />
                </div>
              </div>
              {(status.termenEliberare || status.opozitieEnd) && (
                <div className="f-row">
                  {status.termenEliberare && <DeadlineChip label="Taxa eliberare (4 luni)" date={status.termenEliberare} act />}
                  {status.termenContestatie && <DeadlineChip label="Termen contestatie (3 luni)" date={status.termenContestatie} />}
                  {status.opozitieEnd && <DeadlineChip label="Sfarsit opozitie (6 luni)" date={status.opozitieEnd} />}
                </div>
              )}

              <div className="tr-divider">Finalizare</div>

              <div className="field">
                <label>Nr. brevet</label>
                <input type="text" value={r.numarBrevet} onChange={e => set({ numarBrevet: e.target.value })} placeholder="ex. 131234" className="mono" />
              </div>
              <div className="field">
                <label>Data inregistrarii</label>
                <DateField value={r.dataInregistrare || ''} onChange={v => set({ dataInregistrare: v })} />
              </div>
              <div className="field">
                <label>Data expirarii</label>
                <DateField value={r.dataExpirare || ''} onChange={v => set({ dataExpirare: v })} />
              </div>
              <label className="check-label">
                <input type="checkbox" checked={r.taxaEliberarePlatita} onChange={e => set({ taxaEliberarePlatita: e.target.checked })} />
                Taxa de publicare, tiparire si eliberare a fost achitata
              </label>
              <label className="check-label">
                <input type="checkbox" checked={r.brevetPrimit} onChange={e => set({ brevetPrimit: e.target.checked })} />
                Brevetul a fost primit
              </label>
              <label className={`check-label${!r.brevetPrimit ? ' disabled' : ''}`}>
                <input type="checkbox" disabled={!r.brevetPrimit} checked={r.transmisClient} onChange={e => set({ transmisClient: e.target.checked })} />
                Brevetul a fost transmis catre client
              </label>
            </div>
          )}
        </TrackerCard>
      )}

      {/* ══ OSIM — Anuitati national ══ */}
      {isOsim && (
        <TrackerCard title="Mentinerea in vigoare (anuitati OSIM)" collapsible defaultOpen={false}
          badge={anuOsim.rows.length > 0 ? `rest de plata: ${fmtLei(anuOsim.totalRamas)}` : undefined}>
          {!r.dataDepunere ? (
            <p className="f-hint">Introdu data de depozit pentru a genera scadentarul pe 20 de ani.</p>
          ) : (
            <>
              <p className="f-hint mb8">Anii 1 si 2 sunt scutiti. Taxele pentru primii ani se platesc in 12 luni de la publicarea mentiunii. Intarzierea se acopera in 6 luni cu majorare de 50%.</p>
              <AnuitatiTable rows={anuOsim.rows} onToggle={an => toggleAn('anuitati', an)} lei />
              {anuOsim.expirare && (
                <p className="f-hint mt8">Brevet expira: <strong>{fmtRO(anuOsim.expirare)}</strong> — Total estimat (20 ani): <strong>{fmtLei(anuOsim.totalIntegral)}</strong></p>
              )}
            </>
          )}
        </TrackerCard>
      )}

      {/* ══ EPO — Procedura la OEB ══ */}
      {isEpo && (
        <TrackerCard title="Procedura la OEB">
          <label className="check-label">
            <input type="checkbox" checked={r.depusa} onChange={e => set({ depusa: e.target.checked })} />
            <strong>Cererea a fost depusa la OEB</strong>
          </label>
          {r.depusa && (
            <div className="dep-section">
              <div className="f-row">
                <div className="field">
                  <label>Nr. cerere EP</label>
                  <input type="text" value={r.numarCerere || r.numar} onChange={e => set({ numarCerere: e.target.value })} placeholder="ex. 26 123 456.7" className="mono" />
                </div>
                <div className="field">
                  <label>Data de depozit</label>
                  <DateField value={r.dataDepunere} onChange={v => set({ dataDepunere: v })} />
                </div>
              </div>
              <div className="f-row">
                <div className="field">
                  <label>Nr. publicare (A1/A2)</label>
                  <input type="text" value={r.numarPublicare} onChange={e => set({ numarPublicare: e.target.value })} placeholder="EP 4 123 456 A1" className="mono" />
                </div>
                <div className="field">
                  <label>Nr. brevet (B1)</label>
                  <input type="text" value={r.numarBrevet} onChange={e => set({ numarBrevet: e.target.value })} placeholder="EP 4 123 456 B1" className="mono" />
                </div>
                <div className="field">
                  <label>Data inregistrarii</label>
                  <DateField value={r.dataInregistrare || ''} onChange={v => set({ dataInregistrare: v })} />
                </div>
                <div className="field">
                  <label>Data expirarii</label>
                  <DateField value={r.dataExpirare || ''} onChange={v => set({ dataExpirare: v })} />
                </div>
              </div>
              {status.termenTaxeInitiale && (
                <div className="f-row">
                  <DeadlineChip label="Taxe depunere + documentare (1 luna)" date={status.termenTaxeInitiale} act />
                  {status.publicare && <DeadlineChip label="Publicare estimata (18 luni)" date={status.publicare} />}
                </div>
              )}
              <label className="check-label mt4">
                <input type="checkbox" checked={r.taxeInitialePlatite} onChange={e => set({ taxeInitialePlatite: e.target.checked })} />
                Taxele de depunere si de documentare au fost achitate
              </label>

              <div className="tr-divider">Documentare si examinare</div>

              <div className="field">
                <label>Data publicarii mentiunii raportului european de documentare <span className="f-hint">— de la aceasta data curg 6 luni pentru cererea de examinare</span></label>
                <DateField value={r.dataRaport} onChange={v => set({ dataRaport: v })} />
              </div>
              {status.termenExaminare && (
                <div className="f-row">
                  <DeadlineChip label="Cerere de examinare (6 luni)" date={status.termenExaminare} act />
                  <DeadlineChip label="Taxa de desemnare (6 luni)" date={status.termenExaminare} act />
                </div>
              )}
              <label className="check-label">
                <input type="checkbox" checked={r.examinareCeruta} onChange={e => set({ examinareCeruta: e.target.checked })} />
                Examinarea a fost ceruta si taxele achitate
              </label>

              <div className="tr-divider">Acordare</div>

              <div className="field">
                <label>Data comunicarii conform R. 71(3) <span className="f-hint">— 4 luni pentru taxa de acordare</span></label>
                <DateField value={r.data71_3} onChange={v => set({ data71_3: v })} />
              </div>
              <label className="check-label">
                <input type="checkbox" checked={r.taxaAcordarePlatita} onChange={e => set({ taxaAcordarePlatita: e.target.checked })} />
                Taxa de acordare achitata si traducerile depuse
              </label>
              <div className="field">
                <label>Data publicarii mentiunii eliberarii in Buletinul European <span className="f-hint">— porneste termenele de validare, opozitia de 9 luni</span></label>
                <DateField value={r.dataMentiuneEliberare} onChange={v => set({ dataMentiuneEliberare: v })} />
              </div>
              {status.opozitieEnd && (
                <div className="f-row">
                  <DeadlineChip label="Sfarsit opozitie (9 luni)" date={status.opozitieEnd} />
                  <DeadlineChip label="Cerere efect unitar (1 luna)" date={status.termenUnitar} act />
                </div>
              )}
            </div>
          )}
        </TrackerCard>
      )}

      {/* ══ EPO — Anuitati OEB pe durata examinarii ══ */}
      {isEpo && anuOEB.rows.length > 0 && (
        <TrackerCard title="Anuitati la OEB (pe durata examinarii)" collapsible defaultOpen={false}
          badge={fmtEur(anuOEB.total)}>
          <p className="f-hint mb8">Se datoreaza din al treilea an, in ultima zi a lunii care contine aniversarea datei de depozit. Intarzierea e posibila in 6 luni, cu suprataza de 50%.</p>
          <AnuitatiTable rows={anuOEB.rows} onToggle={an => toggleAn('anuitatiOEB', an)} />
        </TrackerCard>
      )}

      {/* ══ EPO — Efecte in Romania ══ */}
      {isEpo && (
        <TrackerCard title="Efecte in Romania">
          <label className="check-label">
            <input type="checkbox" checked={r.protectieProvizorie} onChange={e => set({ protectieProvizorie: e.target.checked })} />
            Traducerea revendicarilor publicata pentru protectie provizorie (pct. 29 — {taxeOsimVal.revendicari_provizoriu} lei)
          </label>
          <label className="check-label">
            <input type="checkbox" checked={r.validareRO} onChange={e => set({ validareRO: e.target.checked })} />
            <strong>Se valideaza in Romania</strong>
          </label>
          {r.validareRO && (
            <div className="dep-section">
              <div className="field">
                <label>Termenul de depunere a traducerii fasciculei <span className="f-hint">— 3 luni de la mentiune; in urmatoarele 3 luni taxa se dubleaza</span></label>
                <SegControl value={r.validareROTermen} onChange={v => set({ validareROTermen: v })}
                  options={[['3luni',`In 3 luni (${taxeOsimVal.fascicul_3luni} lei)`],['6luni',`In 6 luni (${taxeOsimVal.fascicul_6luni} lei)`]]} />
              </div>
              <div className="field">
                <label>Nr. pagini ale fasciculei traduse <span className="f-hint">— peste 20 pag.: {taxeOsimVal.fascicul_pagina} lei/pag. suplimentara</span></label>
                <input type="number" min="1" value={r.validareROPagini} onChange={e => set({ validareROPagini: Number(e.target.value) || 0 })} />
              </div>
              <table className="fee-table">
                <tbody>
                  {r.protectieProvizorie && <FeeRow lei label="Publicarea traducerii revendicarilor (pct. 29)" value={taxeCalcOsimVal.provizoriu} />}
                  <FeeRow lei label={`Publicarea traducerii fasciculei (pct. 31${r.validareROTermen === '6luni' ? 'b' : 'a'})`} value={taxeCalcOsimVal.baza} />
                  {taxeCalcOsimVal.pagSupl > 0 && <FeeRow lei label={`Pagini peste 20 (${taxeCalcOsimVal.pagSupl} × ${taxeOsimVal.fascicul_pagina} lei)`} value={taxeCalcOsimVal.paginiSupl} />}
                  {r.certificatRecunoastere && <FeeRow lei label="Certificat de recunoastere a efectelor (pct. 37)" value={taxeCalcOsimVal.certificat} />}
                </tbody>
                <tfoot>
                  <tr className="fee-total">
                    <td>Total taxe OSIM pentru validare</td>
                    <td>{fmtLei(taxeCalcOsimVal.total)}</td>
                  </tr>
                </tfoot>
              </table>
              <p className="f-hint mt4">Reducerile de taxe din art. 2 O.G. 41/1998 nu se aplica acestor proceduri (art. 10 alin. 1).</p>
              {status.termenValidare && (
                <div className="f-row mt4">
                  <DeadlineChip label="Termen depunere traducere" date={status.termenValidare} act />
                </div>
              )}
              <label className="check-label mt4">
                <input type="checkbox" checked={r.validareRODepusa} onChange={e => set({ validareRODepusa: e.target.checked })} />
                Traducerea fasciculei a fost depusa la OSIM
              </label>
              <label className="check-label">
                <input type="checkbox" checked={r.certificatRecunoastere} onChange={e => set({ certificatRecunoastere: e.target.checked })} />
                S-a solicitat certificatul de recunoastere a efectelor (pct. 37 — {taxeOsimVal.certificat_recunoastere} lei)
              </label>
            </div>
          )}
        </TrackerCard>
      )}

      {/* ══ EPO — Anuitati OSIM pentru brevet european validat ══ */}
      {isEpo && anuRO.rows.length > 0 && (
        <TrackerCard title="Anuitati la OSIM (brevet european validat)" collapsible defaultOpen={false}
          badge={fmtLei(anuRO.total)}>
          <p className="f-hint mb8">La OSIM se platesc anii care urmeaza anului in care OEB a publicat mentiunea eliberarii. Intarzierea se poate acoperi in 6 luni cu majorare de 50%.</p>
          <AnuitatiTable rows={anuRO.rows} onToggle={an => toggleAn('anuitatiRO', an)} lei />
        </TrackerCard>
      )}

      {/* ══ EPO — Validari in alte state + efect unitar ══ */}
      {isEpo && (
        <TrackerCard title="Efect unitar si validare in celelalte state" collapsible defaultOpen={false}>
          <label className="check-label">
            <input type="checkbox" checked={r.unitar} onChange={e => set({ unitar: e.target.checked })} />
            <strong>Se solicita efect unitar</strong>
            <span className="f-hint"> — cerere in 1 luna de la mentiunea eliberarii</span>
          </label>
          {r.unitar && (
            <label className="check-label" style={{ marginLeft: 22 }}>
              <input type="checkbox" checked={r.cerereUnitaraDepusa} onChange={e => set({ cerereUnitaraDepusa: e.target.checked })} />
              Cererea de efect unitar a fost depusa
            </label>
          )}
          <p className="f-hint mt4 mb8">Bifa statele de validare si completeaza costul estimat (taxa + traducere + mandatar local). Regimul lingvistic este orientativ.</p>
          <div className="state-grid">
            {STATE_VALIDARE.map(([cod, nume, regim]) => {
              const sel = !!r.validari[cod];
              return (
                <div key={cod} className={`state-row${sel ? ' state-row-sel' : ''}`}>
                  <label className="check-label">
                    <input type="checkbox" checked={sel} onChange={() => toggleStat(cod)} />
                    <span className="mono" style={{ minWidth: 36 }}>{cod}</span>
                    <span style={{ flex: 1 }}>{nume}</span>
                    <span className={`regim-badge regim-${regim}`}>{REGIM_LABEL[regim]}</span>
                  </label>
                  {sel && (
                    <div className="field" style={{ marginLeft: 22, marginTop: 4 }}>
                      <label>Cost estimat (€)</label>
                      <input type="number" min="0" value={r.validari[cod].cost}
                        onChange={e => set({ validari: { ...r.validari, [cod]: { cost: Number(e.target.value) || 0 } } })} />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          {costValidari > 0 && <p className="f-hint mt8">Cost total estimat validari: <strong>{fmtEur(costValidari)}</strong></p>}
        </TrackerCard>
      )}

      {/* ══ EPO — Anuitati brevet unitar ══ */}
      {isEpo && anuUnitar.rows.length > 0 && (
        <TrackerCard title="Anuitati pentru brevetul cu efect unitar" collapsible defaultOpen={false}
          badge={fmtEur(anuUnitar.total)}>
          <p className="tr-note">Cuantumurile sunt orientative — verifica grila in vigoare la OEB inainte de a le folosi intr-o oferta si corecteaza-le in panoul de tarife.</p>
          <AnuitatiTable rows={anuUnitar.rows} onToggle={an => toggleAn('anuitatiUnitar', an)} />
        </TrackerCard>
      )}

      {/* ══ EPO — Sinteza costuri ══ */}
      {isEpo && (
        <TrackerCard title="Sinteza costurilor oficiale">
          <table className="fee-table">
            <tbody>
              <FeeRow label="Taxe OEB pana la eliberare" value={taxeCalcOeb.total} />
              {anuOEB.total > 0 && <FeeRow label="Anuitati OEB pe durata examinarii" value={anuOEB.total} />}
              {costValidari > 0 && <FeeRow label="Validari in alte state (estimat)" value={costValidari} />}
              {anuUnitar.total > 0 && <FeeRow label="Anuitati brevet unitar" value={anuUnitar.total} />}
            </tbody>
          </table>
          {(taxeCalcOsimVal.total > 0 || anuRO.total > 0) && (
            <>
              <div className="tr-divider">Taxe OSIM (Romania)</div>
              <table className="fee-table">
                <tbody>
                  {taxeCalcOsimVal.total > 0 && <FeeRow lei label="Taxe OSIM pentru efectele in Romania" value={taxeCalcOsimVal.total} />}
                  {anuRO.total > 0 && <FeeRow lei label="Anuitati OSIM" value={anuRO.total} />}
                </tbody>
              </table>
            </>
          )}
          <p className="f-hint mt4">Sumele in euro si cele in lei se afiseaza separat — conversia se face la cursul de la data platii.</p>
        </TrackerCard>
      )}

            {/* ── Reinnoire ── */}
      <ReinnoireCard r={r} set={set} TrackerCard={TrackerCard} />

      {/* ══ Observatii ══ */}
      <TrackerCard title="Observatii interne">
        <textarea className="tr-textarea" value={r.observatii} onChange={e => set({ observatii: e.target.value })} rows={3}
          placeholder="Note de dosar, corespondenta cu examinatorul, mandatari locali…" />
      </TrackerCard>

      {/* Documente inregistrare */}
      <TrackerCard title="Documente inregistrare">
        <ProceduraFileSection
          procId={procId}
          showToast={showToast}
          pendingFiles={pendingFiles}
          onPendingFilesChange={onPendingFilesChange}
          tipOptions={['Duplicat Cerere inregistrare', 'Copie Certificat Inregistrare']}
          keyPrefix="inreg"
        />
      </TrackerCard>
    </div>
  );
}

/* ── Sub-components ── */
function AlertBanner({ status }) {
  const { alert } = status;
  return (
    <div className={`tr-alert sev-${alert.sev}`}>
      <strong>{alert.label}</strong>
      {alert.date && (
        <span className="tr-alert-date">
          Termen: {fmtRO(alert.date)}
          {typeof alert.daysLeft === 'number' && (
            alert.daysLeft < 0
              ? ` · depasit cu ${Math.abs(alert.daysLeft)} zile`
              : ` · ${alert.daysLeft} zile ramase`
          )}
        </span>
      )}
    </div>
  );
}

function Timeline({ steps }) {
  const activeIdx = steps.findIndex(s => !s.done);
  return (
    <div className="tr-timeline">
      {steps.map((s, i) => {
        const isActive = i === activeIdx;
        const done = s.done;
        return (
          <React.Fragment key={s.key}>
            {i > 0 && <span className={`tl-line${done || steps[i-1].done ? ' tl-line-done' : ''}`} />}
            <div className="tl-step">
              <span className={`tl-dot${done ? ' done' : isActive ? ' active' : ''}`}>{done ? '✓' : i + 1}</span>
              <span className={`tl-label${isActive ? ' active' : done ? ' done' : ''}`}>{s.label}</span>
              {s.date && <span className="tl-date">{fmtRO(s.date)}</span>}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}

function TrackerCard({ title, badge, children, collapsible = false, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);
  const isOpen = !collapsible || open;
  return (
    <div className="tr-card">
      <div className={`tr-card-head${collapsible ? ' tr-card-head-toggle' : ''}`}
        onClick={collapsible ? () => setOpen(o => !o) : undefined}>
        <span className="tr-card-title">{title}</span>
        <div className="tr-card-head-right">
          {badge && <span className="tr-badge">{badge}</span>}
          {collapsible && <span className={`tr-card-arrow${isOpen ? ' tr-card-arrow-open' : ''}`}>›</span>}
        </div>
      </div>
      {isOpen && <div className="tr-card-body">{children}</div>}
    </div>
  );
}

function SegControl({ value, onChange, options, disabled }) {
  return (
    <div className={`seg-ctrl${disabled ? ' seg-disabled' : ''}`}>
      {options.map(([v, label]) => (
        <button key={v} type="button" disabled={disabled}
          className={`seg-btn${value === v ? ' seg-active' : ''}`}
          onClick={() => !disabled && onChange(v)}>
          {label}
        </button>
      ))}
    </div>
  );
}

function FeeRow({ label, value, strong, muted, lei }) {
  return (
    <tr className={strong ? 'fee-strong' : muted ? 'fee-muted' : ''}>
      <td>{label}</td>
      <td className="fee-val">{lei ? fmtLei(value) : fmtEur(value)}</td>
    </tr>
  );
}

function DeadlineChip({ label, date, act }) {
  if (!date) return null;
  const dl = daysLeft(date);
  const overdue = dl < 0;
  const soon = dl >= 0 && dl <= 60;
  const cls = overdue ? 'chip-overdue' : (act && soon) ? 'chip-act' : 'chip-neutral';
  return (
    <div className={`deadline-chip ${cls}`}>
      <span>{label}</span>
      <span>{fmtRO(date)} · {overdue ? `${Math.abs(dl)}z depasit` : `${dl}z`}</span>
    </div>
  );
}

function AnuitatiTable({ rows, onToggle, lei }) {
  return (
    <table className="fee-table">
      <thead>
        <tr>
          <th>Anul</th>
          <th>Scadenta</th>
          <th>Gratie</th>
          <th>Suma</th>
          <th>Platit</th>
        </tr>
      </thead>
      <tbody>
        {rows.map(row => {
          const dl = daysLeft(row.scadenta);
          const overdue = !row.platit && dl < 0;
          return (
            <tr key={row.an} className={row.platit ? 'fee-row-done' : overdue ? 'fee-row-overdue' : ''}>
              <td className="mono">Anul {row.an}{row.redus ? ' ↓' : ''}</td>
              <td className="mono">{fmtRO(row.scadenta)}{!row.platit && dl != null ? ` · ${overdue ? `${Math.abs(dl)}z dep.` : `${dl}z`}` : ''}</td>
              <td className="mono">{fmtRO(row.gratie)}</td>
              <td>{lei ? fmtLei(row.suma) : fmtEur(row.suma)}</td>
              <td><input type="checkbox" checked={row.platit} onChange={() => onToggle(row.an)} /></td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

function TarifeEditorOsim({ tarife, anuitati, setTarife, setAnuitati }) {
  const taxeFields = [
    ['inreg_electronic','Inregistrare electronic (lei)'],['inreg_hartie','Inregistrare hartie (lei)'],
    ['publicare_18','Publicare 18 luni (lei)'],['publicare_anticipata','Publicare anticipata (lei)'],
    ['raport_national','Raport national (lei)'],['raport_international','Raport international (lei)'],['raport_extins','Raport extins (lei)'],
    ['exam_baza','Examinare baza (lei)'],['exam_pagina','Examinare pagina (lei)'],['exam_revendicare','Examinare revendicare (lei)'],
    ['exam_rapid_baza','Examinare rapida baza (lei)'],['exam_rapid_pagina','Ex. rapida pagina (lei)'],['exam_rapid_revendicare','Ex. rapida revendicare (lei)'],
    ['eliberare','Eliberare brevet (lei)'],['eliberare_pagina','Eliberare pagina (lei)'],
    ['prioritate','Prioritate (lei)'],['faza_nationala','Faza nationala PCT (lei)'],
  ];
  return (
    <div className="tarife-editor">
      <div className="tr-divider">Taxe procedura OSIM</div>
      {taxeFields.map(([k, lbl]) => (
        <label key={k} className="tarife-field">
          {lbl}
          <input type="number" value={tarife[k] ?? 0}
            onChange={e => setTarife({ ...tarife, [k]: Number(e.target.value) || 0 })} />
        </label>
      ))}
      <div className="tr-divider">Anuitati OSIM (lei / an de protectie)</div>
      {Object.keys(anuitati).map(an => (
        <label key={an} className="tarife-field">
          Anul {an}
          <input type="number" value={anuitati[an] ?? 0}
            onChange={e => setAnuitati({ ...anuitati, [an]: Number(e.target.value) || 0 })} />
        </label>
      ))}
    </div>
  );
}

function TarifeEditorOeb({ taxe, setTaxe, anuOEB, setAnuOEB, anuOsimVal, setAnuOsimVal, anuUnitar, setAnuUnitar }) {
  const fields = [
    ['depunere_online','Depunere online (EUR)'],['depunere_hartie','Depunere hartie (EUR)'],
    ['pagina_peste_35','Pagina peste 35 (EUR)'],['documentare','Documentare (EUR)'],
    ['desemnare','Desemnare (EUR)'],['examinare_1','Examinare tip 1 (EUR)'],['examinare_2','Examinare tip 2 (EUR)'],
    ['revendicare_16_50','Revendicare 16–50 (EUR)'],['revendicare_51','Revendicare 51+ (EUR)'],
    ['acordare','Acordare si publicare (EUR)'],['opozitie','Opozitie (EUR)'],
    ['continuare_procedura','Continuarea procedurii (EUR)'],['restabilire','Restabilire drepturi (EUR)'],
  ];
  return (
    <div className="tarife-editor">
      <div className="tr-divider">Taxe procedura OEB (EUR)</div>
      {fields.map(([k, lbl]) => (
        <label key={k} className="tarife-field">
          {lbl}
          <input type="number" value={taxe[k] ?? 0}
            onChange={e => setTaxe({ ...taxe, [k]: Number(e.target.value) || 0 })} />
        </label>
      ))}
      <div className="tr-divider">Anuitati OEB pe durata examinarii (EUR)</div>
      {Object.keys(anuOEB).map(an => (
        <label key={an} className="tarife-field">
          Anul {an}
          <input type="number" value={anuOEB[an] ?? 0}
            onChange={e => setAnuOEB({ ...anuOEB, [an]: Number(e.target.value) || 0 })} />
        </label>
      ))}
      <div className="tr-divider">Anuitati OSIM brevet EP validat (lei)</div>
      {Object.keys(anuOsimVal).map(an => (
        <label key={an} className="tarife-field">
          Anul {an}
          <input type="number" value={anuOsimVal[an] ?? 0}
            onChange={e => setAnuOsimVal({ ...anuOsimVal, [an]: Number(e.target.value) || 0 })} />
        </label>
      ))}
      <div className="tr-divider">Anuitati brevet cu efect unitar (EUR, orientativ)</div>
      {Object.keys(anuUnitar).map(an => (
        <label key={an} className="tarife-field">
          Anul {an}
          <input type="number" value={anuUnitar[an] ?? 0}
            onChange={e => setAnuUnitar({ ...anuUnitar, [an]: Number(e.target.value) || 0 })} />
        </label>
      ))}
    </div>
  );
}
